module.exports = __webpack_public_path__ + "img/download.dae91d13.svg";